import ReactMarkdown from 'react-markdown'

// Rendu markdown volontairement DISCRET : titres en petites capitales grises,
// texte fin, puces sobres, gras à peine marqué. Pas de gros titres gras.
export const md = {
    h1: ({ children }) => (
        <h3 className="mt-5 mb-2 text-[11px] font-semibold uppercase tracking-wider text-gray-400 first:mt-0">
            {children}
        </h3>
    ),
    h2: ({ children }) => (
        <h4 className="mt-4 mb-1.5 text-xs font-medium uppercase tracking-wide text-gray-400 first:mt-0">
            {children}
        </h4>
    ),
    h3: ({ children }) => (
        <h5 className="mt-3 mb-1 text-xs font-medium text-gray-500">
            {children}
        </h5>
    ),
    p: ({ children }) => (
        <p className="my-2 text-[13px] leading-relaxed text-gray-600">
            {children}
        </p>
    ),
    ul: ({ children }) => (
        <ul className="my-2 flex flex-col gap-1 pl-4 list-disc marker:text-gray-300">
            {children}
        </ul>
    ),
    ol: ({ children }) => (
        <ol className="my-2 flex flex-col gap-1 pl-4 list-decimal marker:text-gray-300">
            {children}
        </ol>
    ),
    li: ({ children }) => (
        <li className="text-[13px] leading-relaxed text-gray-600">
            {children}
        </li>
    ),
    strong: ({ children }) => (
        <strong className="font-medium text-gray-800">{children}</strong>
    ),
    a: ({ children, href }) => (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 underline decoration-gray-300 underline-offset-2 hover:text-gray-900"
        >
            {children}
        </a>
    ),
    code: ({ children }) => (
        <code className="rounded-sm bg-gray-50 px-1 py-0.5 font-mono text-[11px] text-gray-600">
            {children}
        </code>
    ),
}

// Le TITRE ne se coupe jamais (`whitespace-nowrap`) : dans une colonne étroite,
// c'est l'explication qui passe à la ligne suivante, pas « Style / email ».
export const SectionTitle = ({ children, action, hint }) => (
    <div className="mb-2 flex flex-wrap items-baseline gap-x-3 gap-y-1">
        <h2 className="shrink-0 whitespace-nowrap text-[11px] font-semibold uppercase tracking-wider text-gray-400">
            {children}
        </h2>
        {hint && <span className="min-w-0 text-xs leading-snug text-gray-400">{hint}</span>}
        {action && <div className="ml-auto shrink-0">{action}</div>}
    </div>
)
